import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Build-time SSR snapshots (see scripts/prerender.mjs) populate
// `#root` with translated, pre-rendered markup. When that markup is
// present we must hydrate it instead of blowing it away with a fresh
// render — otherwise crawlers see translated copy but real users see
// a one-frame flash of empty layout. The `data-prerendered` flag is
// stamped by the prerender script onto the saved HTML.
const rootEl = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (rootEl.hasAttribute("data-prerendered")) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
